import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { SubirArchivoService } from "src/app/services/subir-archivo.service";
import { ToastrService } from "ngx-toastr";
declare let $: any;

import * as FileSaver from "file-saver";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xls";

import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { IdentityModel } from "src/app/models/identity.model";
import { SelectsService } from "src/app/services/selects.service";
import { HelperService } from "src/app/services/helper.service";
import { PaginationComponent } from "../layout/pagination/pagination.component";

@Component({
  selector: "app-carga",
  templateUrl: "./carga.component.html",
  styleUrls: ["./carga.component.scss"]
})
export class CargaComponent implements OnInit {
  // File input
  public test123 =
    "https://desarrollo.covinoc.com:28443/CoviRecuperaQA/servicios/exportar_convertir_a_xls";
  public ExcelFile =
    "http://200.41.76.20/CoviRecuperaAfiliado/Formato_cargue_cartera_CoviRecupera.xlsx";
  public urlApi = "http://desarrollo.covinoc.com:8180/CoviRecupera/archivos";
  public formImport: FormGroup;
  public fileToUpload: File = null;
  public fileToUpload2: File = null;
  public archivoSubir: File;
  public menssageError = [];
  public files: File[] = [];
  public fileUrl: any;
  public player = {};

  // Tablas
  public titlesError = [];
  public filasErroneas = [];
  public mensajesError = [];
  public columnasErroneas: any;
  public titlesOk: any;
  public filasCorrectos: any;
  public columnasCorrectos: any;

  RutaDinamica =
    "http://desarrollo.covinoc.com:8180/CoviRecupera/archivos/reporte.xls";

  // Propiedades
  public urlApiSendFiles = "pr_carga_masiva";
  public blankState = false;
  public userData = new IdentityModel();
  public title = "CoviRecupera";
  public data = {};
  @ViewChild("labelImport")
  labelImport: ElementRef;
  @ViewChild("labelImport2")
  labelImport2: ElementRef;

  // Excel front
  dataExcelFront = [];

  // propiedades
  public identity: any;
  public ToggleNombre: any;
  public togglePopOver = false;
  public clientX: number;
  public clientY: number;
  public messageTooltip: string;
  public currentPageOkRegs: number = 0;
  public currentPageErrorRegs: number = 0;
  public itemsPerPage: number = 10;

  // Efectos
  public hoverEffect = false;
  public hoverDiv: number;

  // Angular
  @ViewChild("inputFileValue") inputFileValue: any;
  @ViewChild("paginationComponent") paginationComponent: PaginationComponent;
  // Ajax
  public dataTempLoad: any;
  public dataOkRegs: any;
  public dataErrorRegs: any;

  public dataExcelExport: any;

  // Body enviar
  public validateJsonRegs = {
    CARGA: {
      REGISTROS_CORRECTOS: []
    }
  };
  public sendObligations: Array<any> = [];
  public historicoEnviar: Array<any> = [];
  public base64Files: Array<any> = [];

  // Formatos
  public word: string;
  public xml: string;
  public pdf: string;
  public png: string;
  public jpg: string;
  // Respuesta Cargue de cartera
  public registrosRechazados = 0;
  public registrosSinProcesar = 0;
  public registrosCargados = 0;
  public grupoCarga: string;

  public Analytics: any;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private subirArchivoService: SubirArchivoService,
    private toastr: ToastrService,
    private selects: SelectsService,
    public helper: HelperService
  ) {
    this.word =
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    this.xml = "text/xml";
    this.pdf = "application/pdf";
    this.png = "image/png";
    this.jpg = "image/jpeg";
  }

  ngOnInit() {
    this.Analytics = JSON.parse(localStorage.getItem("identityCVE"));
  }

  pageSelectedOkRegisters({ currentPage }) {
    this.currentPageOkRegs = currentPage;
  }

  pageSelectedErrorRegisters({ currentPage }) {
    this.currentPageErrorRegs = currentPage;
  }

  isObject(val: any) {
    return typeof val === "object";
  }

  closeModal() {
    $("#modalUpFile").modal("hide");
  }

  // DropZone
  onSelect(event) {
    this.archivoSubir = event.addedFiles[0];
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
    this.archivoSubir = null;
  }

  trackByFn(index: number, item: any): number {
    return index;
  }

  enterTd(item: any, title: string, event: any) {
    this.clientX = event.x;
    this.clientY = event.y;
    if (item.MENSAJE[title] !== undefined) {
      this.togglePopOver = true;
      this.messageTooltip = item.MENSAJE[title];
      this.selects.sendMessage(this.messageTooltip);
    } else {
      this.togglePopOver = false;
      this.messageTooltip = "";
      this.selects.sendMessage(this.messageTooltip);
    }
  }

  leaveTd() {
    this.togglePopOver = false;
    this.messageTooltip = "";
    this.selects.sendMessage(this.messageTooltip);
  }

  confirmSelection() {
    $("#modalUpFile").modal("hide");
    this.toastr.info(
      "Los archivos se enviarán al enviar la Radicación.",
      null,
      {
        timeOut: 5000,
        positionClass: "toast-bottom-full-width"
      }
    );
  }

  uploadFile(
    nombre?: string,
    genero?: string,
    tipoDeudor?: string,
    formEnviar?: any
  ) {
    (window as any).gtag("event", "cargue_antes_formato", {
      event_category: `${this.Analytics.v_tipo_documento} ${this.Analytics.v_documento}`,
      event_label: ""
    });

    this.spinner.show();
    this.subirArchivoService
      .uploadFile(this.data, this.archivoSubir, this.urlApiSendFiles)
      .subscribe(
        (resp: any) => {
          this.spinner.hide();
          // Vacio
          if (
            resp &&
            resp.CARGA &&
            resp.CARGA.REGISTROS_CORRECTOS.length < 1 &&
            resp.CARGA.REGISTROS_ERROR.length < 1
          ) {
            Swal.fire({
              position: "center",
              type: "error",
              title: "Excel sin registros.",
              text:
                "Intente nuevamente, con un archivo que contenga registros.",
              allowOutsideClick: false,
              showConfirmButton: true
            });
            this.router
              .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
              .then(() => {
                this.router.navigate(["carga"]);
              });
          }

          // Cargo todo sin errores
          if (resp && resp.CARGA_COVIRECUPERA) {
            const response = resp.CARGA_COVIRECUPERA[0];
            Swal.close();
            // Descargar rechazos
            $("#ModalRespuestaCargue").modal("show");
            this.registrosRechazados = response.rechazados;
            this.registrosSinProcesar = response.sinprocesar;
            this.registrosCargados = response.cargados;
            this.grupoCarga = response.grupo_carga;
          } else if (resp) {
            // Cargo errores en el excel
            this.blankState = true;

            if (resp && resp.CARGA && resp.CARGA.REGISTROS_ERROR) {
              this.dataErrorRegs = resp.CARGA.REGISTROS_ERROR;
              //this.menssageError = Object.keys(this.dataErrorRegs[0]);
              // Si hay errores...
              if (resp && resp.CARGA && resp.CARGA.REGISTROS_ERROR.length > 0) {
                this.toastr.info(
                  "Edite las casillas marcadas con error.",
                  null,
                  {
                    timeOut: 3000
                  }
                );
              }
            }
            if (this.dataErrorRegs && this.dataErrorRegs.length > 0) {
              this.titlesError = Object.keys(this.dataErrorRegs[0]);
              this.dataErrorRegs.forEach((element: any, index: any) => {
                // Leer mensajes de error
                const errorKeys = Object.values(element.MENSAJE);
                this.mensajesError.push(errorKeys);
                const test = Object.values(element);
                const send = Object.assign({}, test);
                this.filasErroneas.push(send);
              });
            }

            this.dataOkRegs = resp.CARGA.REGISTROS_CORRECTOS;
            if (this.dataOkRegs && this.dataOkRegs.length > 0) {
              this.titlesOk = Object.keys(this.dataOkRegs[0]);
            }
          }

          // this.inputFileValue.nativeElement.value = '';
          this.archivoSubir = null;
          this.files = [];

          $("#modalUpFile").modal("hide");
        },
        (err: any) => {
          this.blankState = false;
          this.spinner.hide();
          const errorMessage = $(err.error)
            .last()
            .text();
          this.toastr.warning(errorMessage, null, {
            timeOut: 4000
          });
        }
      );
  }

  downloadRejections() {
    (window as any).gtag("event", "descargar_rechazos", {
      event_category: `${this.Analytics.v_tipo_documento} ${this.Analytics.v_documento}`,
      event_label: ""
    });

    this.subirArchivoService.downloadRejections(this.grupoCarga).subscribe(
      (resp: any) => {
        this.saveAsExcelFile2(resp, "rechazos_covirecupera");
      },
      (err: any) => {
        console.error(err);
        const errorMessage = $(err.error)
          .last()
          .text();
        this.toastr.warning(errorMessage, null, {
          timeOut: 4000
        });
      }
    );
  }

  private saveAsExcelFile2(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName);
  }

  downloadTemplate() {
    this.spinner.show();
    this.subirArchivoService.dwonloadExcelTemplate().subscribe(
      (resp: any) => {
        this.saveAsExcelFile3(resp, "cargue_covirecupera");
        setTimeout(() => {
          this.spinner.hide();
          //$("#modalUpFile").modal("show");
        }, 3000);
      },
      (err: any) => {
        console.error(err);
        this.spinner.hide();
        const errorMessage = $(err.error)
          .last()
          .text();
        this.toastr.warning(errorMessage, null, {
          timeOut: 4000
        });
      }
    );
  }

  private saveAsExcelFile3(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName);
  }

  deleteRow(id?: number, items?: any) {
    this.dataErrorRegs.splice(id, 1);
    const currentPage = this.helper.getAmountOfPages(
      items.length,
      this.itemsPerPage
    );
    if (this.currentPageErrorRegs > currentPage) {
      this.paginationComponent.selectPage(currentPage - 1);
    }
  }

  deleteRows() {
    this.dataErrorRegs = [];
  }

  mouseEnter(index: any) {
    this.hoverEffect = true;
    this.hoverDiv = index;
  }

  mouseLeave(index: any) {
    this.hoverEffect = false;
    this.hoverDiv = index;
  }

  validateRegs(fila?: any, titleError?: string, newValue?: string, id?: any) {
    fila[titleError] = newValue;
    this.spinner.show();
    // Validar si el registro ya existe en registros exitosos
    const validate = this.dataOkRegs.filter((item: any) => {
      return (
        item.DOCUMENTO === fila.DOCUMENTO &&
        item.TIPO_DOCUMENTO === fila.TIPO_DOCUMENTO &&
        item.OBLIGACION === fila.OBLIGACION &&
        item.NUMERO_DE_TITULO === fila.NUMERO_DE_TITULO &&
        item.NUMERO_DE_FACTURA === fila.NUMERO_DE_FACTURA
      );
    });

    if (validate.length > 0) {
      this.spinner.hide();
      return Swal.fire({
        type: "error",
        title: "Registro Duplicado",
        text: `El registro con documento ${fila.DOCUMENTO} ya está cargado en registros
               exitosos. Por favor elimínelo o edítelo en caso de ser necesario.`
      });
    } else {
      this.validateJsonRegs.CARGA.REGISTROS_CORRECTOS.push(fila);
    }
    // ./Validar si el registro ya existe en registros exitosos

    this.subirArchivoService
      .jsonValidate(this.data, this.validateJsonRegs, this.urlApiSendFiles)
      .subscribe(
        (resp: any) => {
          this.spinner.show();
          // console.log('respues ta de validar', resp);

          if (resp) {
            // Cargo errores en el excel

            if (resp && resp.CARGA && resp.CARGA.REGISTROS_ERROR.length > 0) {
              this.dataErrorRegs[id] = resp.CARGA.REGISTROS_ERROR[0];
              this.dataExcelExport = resp.CARGA;
            }

            if (
              resp.CARGA.REGISTROS_CORRECTOS &&
              resp.CARGA.REGISTROS_CORRECTOS.length === 0
            ) {
              this.validateJsonRegs.CARGA.REGISTROS_CORRECTOS = [];
              this.spinner.hide();
              // console.log('vacio');
              const response = resp.CARGA.REGISTROS_ERROR[0].MENSAJE;
              const keys = Object.values(response);
              const messageToast = keys.join(", ");
              this.toastr.warning(messageToast, "", {
                timeOut: 3000
              });
              return;
            } else if (
              resp.CARGA.REGISTROS_CORRECTOS &&
              resp.CARGA.REGISTROS_CORRECTOS.length > 0
            ) {
              this.validateJsonRegs.CARGA.REGISTROS_CORRECTOS = [];
              this.dataOkRegs.push(resp.CARGA.REGISTROS_CORRECTOS[0]);
              this.dataErrorRegs.splice(id, 1);
              // console.log('contiene');
              this.spinner.hide();
              this.toastr.success("Corrección Exitosa.", null, {
                timeOut: 3000
              });
            }

            if (this.dataOkRegs && this.dataOkRegs.length > 0) {
              this.titlesOk = Object.keys(this.dataOkRegs[0]);
            }
          }

          // console.log('id', id);
          this.spinner.hide();
        },
        (err: any) => {
          console.error(err);
          this.spinner.hide();
        }
      );
  }

  downloadExcel2() {
    this.dataExcelExport = {
      REGISTROS_ERROR: this.dataErrorRegs
    };
    this.subirArchivoService
      .jsonToExcel(this.data, this.dataExcelExport)
      .subscribe(
        res => {
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(res.data, res.filename);
          } else {
            const link = window.URL.createObjectURL(res.data);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.setAttribute("style", "display: none");
            a.href = link;
            a.download = res.filename;
            a.click();
            window.URL.revokeObjectURL(link);
            a.remove();
          }
        },
        error => {
          throw error;
        },
        () => {
          console.log("Completed file download.");
        }
      );
  }

  // Valida json
  upload(event?: any, fila?: any, id?: any, tipo?: string) {
    (window as any).gtag("event", "cargar_formato_ok", {
      event_category: `${this.Analytics.v_tipo_documento} ${this.Analytics.v_documento}`,
      event_label: ""
    });

    this.spinner.show();
    this.dataOkRegs.forEach((element: any, index: any) => {
      this.validateJsonRegs.CARGA.REGISTROS_CORRECTOS.push(element);
    });

    this.subirArchivoService
      .upload(this.data, this.validateJsonRegs, this.urlApiSendFiles)
      .subscribe(
        (resp: any) => {
          (window as any).gtag("event", "fin_cargue", {
            event_category: `${this.Analytics.v_tipo_documento} ${this.Analytics.v_documento}`,
            event_label: ""
          });

          this.spinner.show();

          // Cargue total
          if (resp && resp.CARGA_COVIRECUPERA) {
            const response = resp.CARGA_COVIRECUPERA[0];
            Swal.close();
            // Descargar rechazos
            $("#ModalRespuestaCargue").modal("show");
            this.registrosRechazados = response.rechazados;
            this.registrosSinProcesar = response.sinprocesar;
            this.registrosCargados = response.cargados;
            this.grupoCarga = response.grupo_carga;
          }
          this.spinner.hide();
        },
        (err: any) => {
          console.error(err);
          const errorMessage = $(err.error)
            .last()
            .text();

          Swal.fire({
            type: "error",
            title: "Error al cargar cartera.",
            text: `${errorMessage}`,
            allowOutsideClick: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Entendido"
          }).then(result => {
            this.cancel();
          });
          this.spinner.hide();
        }
      );
  }

  // Descargar archivo
  downloadFile() {
    this.subirArchivoService.dwonloadFile().subscribe(
      (resp: any) => {
        //  console.log('archivo descargado', resp);
        const blob = new Blob([resp.blob()], {
          type: "application/vnd.ms.excel"
        });
        const file = new File([blob], "fileName" + ".xlsx", {
          type: "application/vnd.ms.excel"
        });
        FileSaver.saveAs(file);
        this.saveAsExcelFile(resp, name);
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  downloadExcelFile() {
    this.spinner.show();
    localStorage.removeItem("cartera");
    localStorage.setItem("cartera", JSON.stringify(this.dataErrorRegs));

    setTimeout(() => {
      const arrayTemp = JSON.parse(localStorage.getItem("cartera"));
      const registros = [];

      arrayTemp.forEach((element: any, index: any) => {
        if (element.MENSAJE) {
          element.MENSAJE = JSON.stringify(element.MENSAJE).replace(/{|}/g, "");
        }
        registros.push(element);
      });

      this.subirArchivoService.exportAsExcelFile(
        this.dataErrorRegs,
        "registros-erroneos-cr"
      );
    }, 3000);

    setTimeout(() => {
      this.spinner.hide();
      localStorage.removeItem("cartera");
    }, 5000);
  }

  downloadTemplate2() {
    this.spinner.show();
    const template = [
      {
        TIPO_DOCUMENTO: "",
        DOCUMENTO: "",
        NOMBRE_DEUDOR: "",
        TITULO: "",
        OBLIGACION: "",
        FECHA_VENCIMIENTO: "",
        VALOR_DEUDA: "",
        DIRECCION: "",
        TELEFONO_1: "",
        TELEFONO_2: "",
        EMAIL: "",
        CIUDAD_DIRECCION: ""
      }
    ];

    this.subirArchivoService.exportAsExcelFile2(
      template,
      "plantilla-cartera-cr"
    );

    setTimeout(() => {
      this.spinner.hide();
    }, 3000);

    (window as any).gtag("event", "descarga_formato", {
      event_category: `${this.Analytics.v_tipo_documento} ${this.Analytics.v_documento}`,
      event_label: ""
    });
  }

  popUpLoad() {
    (window as any).gtag("event", "seleccion_archivo", {
      event_category: `${this.Analytics.v_tipo_documento} ${this.Analytics.v_documento}`,
      event_label: ""
    });
  }

  onContentChanged(event: any) {
    const playerName: string = event.target.textContent;
  }

  getExcel() {
    this.RutaDinamica =
      "http://desarrollo.covinoc.com:8180/CoviRecupera/archivos/prueba.xlsx";
  }

  toXslx() {
    const data = {};
    this.subirArchivoService.convertToXslx(data).subscribe(
      (resp: any) => {
        this.RutaDinamica = `${this.urlApi}/${resp.ruta}`;
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  cancel() {
    this.router
      .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
      .then(() => {
        this.router.navigate(["carga"]);
        setTimeout(() => {
          $("#modalUpFile").modal("show");
        }, 1000);
      });
  }
}
